import { observer } from 'mobx-react-lite';
import React, { FC, useContext, useEffect } from 'react';
import '../../scss/distant.scss'
import { Link } from 'react-router-dom';
// import { useNavigate } from 'react-router-dom';
import { Context } from '../..';
import DistantService from '../../services/DistantService';

const DistanceTeacherExpert: FC = () => {
    const { store, distantStore } = useContext(Context)
    //const navigate = useNavigate()

    const getAvatar = async () => {
        const res = await DistantService.getAvatar()
        distantStore.setAvatar(res.data.results[0]['avatar'])
    }

    useEffect(() => {
        if (distantStore.avatar === '') {
            getAvatar()
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleFileChange = (e: React.ChangeEvent<any>) => {
        e.preventDefault();
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        if (file.size < 1048576) {
            reader.onloadend = () => {
                distantStore.createAvatar(reader.result?.toString() || '');
            };
        } else {
            alert('Размер не может превышать 1 МБ!')
        }

    };

    return (
        <div>
            <div className="row">
                <div className="col-md-2 avatar text-end">
                    <img src={distantStore.avatar || '/images/avatar.png'} alt="Аватар" className='avatar image'/>
                    <input className="avatar uploader" type="file" accept='.jpg' onChange={(e) => handleFileChange(e)} />
                </div>
                <div className="col-md-8">
                    <div>{`Личный кабинет эксперта №${store.user.id}`}</div>
                    <div className="h4">{store.specInfo.fio}</div>
                </div>
                <div className="col-md-2">
                    <Link className="nav-link text-success" to="/config">Редактировать</Link>
                    <Link className="nav-link text-success" to="/login" onClick={() => store.logout()}><i className='icon login' />Выход</Link>
                </div>
            </div>
        </div>
    )
};
export default observer(DistanceTeacherExpert);